module.exports = __webpack_public_path__ + "static/media/AB_footer_mobile.2d5d725c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_footer_mobile.png
// module id = 356
// module chunks = 0